import { ServerUrls as Urls } from '@tableau/shared-urls';
import { defaultMemoize } from 'reselect';

import { queryStringSelector } from './selectors/QueryStringSelectors';

/*
 * Constructs urls for server pages, given a query string.
 *
 * e.g.
 *
 *   const serverUrls = ServerUrls.getInstance();
 *   serverUrls.sitesUrl();    // returns '/?foo=bar#/server/sites'
 */

export class ServerUrls extends Urls {

  private static memoizedCreateInstance = defaultMemoize((queryString: string) => new Urls(queryString));

  public static getInstance(): Urls {
    const queryString = queryStringSelector();
    return ServerUrls.memoizedCreateInstance(queryString);
  }

  public static instanceWithCustomQueryStringForTesting(queryString: string) {
    return new Urls(queryString);
  }
}
